// app/error.tsx
'use client';

import {useEffect} from 'react';

type GlobalErrorProps = {
    error: {
        message?: string;
    };
};

export default function GlobalError({error}: GlobalErrorProps) {
    useEffect(() => {
        // console.error('[Next GlobalError]', error);
    }, [error]);

    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <h1 style={styles.title}>出了点问题</h1>
                <p style={styles.message}>
                    {error?.message || '服务器暂时不可用，请稍后再试'}
                </p>
            </div>
        </div>
    );
}

const styles: Record<string, React.CSSProperties> = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #f5f7fa, #e4e8f0)',
        margin: 0,
        fontFamily:
            '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    },

    container: {
        background: '#fff',
        borderRadius: 12,
        padding: '36px 40px',
        width: 420,
        maxWidth: '90%',
        boxShadow: '0 16px 32px rgba(0,0,0,0.12)',
        textAlign: 'center',
    },

    title: {
        fontSize: 22,
        marginBottom: 12,
        color: '#1f1f1f',
        fontWeight: 600,
    },

    message: {
        fontSize: 14,
        lineHeight: 1.6,
        color: '#595959',
    },
};
